import { cva } from 'class-variance-authority';
import { Alert } from '@nula/core-ui';
import { useDocSize } from '@/lib/sync/use-doc-size';
import styles from './doc-size-banner.module.css';

const docSizeBanner = cva(styles.base);

interface Props {
  entityId: string;
}

export function DocSizeBanner({ entityId }: Props) {
  const { level } = useDocSize(entityId);

  if (level === 'ok') return null;

  if (level === 'warn') {
    return (
      <Alert
        type="warning"
        banner
        showIcon
        message="This document is getting large (≥ 5 MB). Performance may be affected."
        className={docSizeBanner()}
      />
    );
  }

  return (
    <Alert
      type="error"
      banner
      showIcon
      message="This document has reached the size limit (10 MB) and is now read-only."
      className={docSizeBanner()}
    />
  );
}
